import React from "react";
import _ from "lodash";

import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";
//import { Day } from "./Day";
import { Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import {
    Button,
    TextField,
    Grid,
    Select,
    MenuItem,
    Typography,
} from "@material-ui/core";
import moment from "moment";
import { connect } from "react-redux";

import { hot } from "react-hot-loader";
import { setEvent } from "./actions";
import {
    selectUserInfo,
    selectVehicleInfo,
    selectEquipmentInfo,
} from "./selectors";

class AddEditEventModal extends React.Component {
    constructor(props) {
        super(props);
        let ev = require("./blankEvent").default;
        ev = this.clearData(ev);
        this.state = {
            event: props.isNewEvent ? ev : props.edit_event,
        };
    }
    clearData = (data) => {
        let ev = {};
        Object.keys(data).map((e) => {
            if (e === "start_date" || e === "end_date")
                ev[e] = moment().format("DD-MM-YYYY");
            else if (Array.isArray(data[e])) ev[e] = [];
            else if (data[e] === null) ev[e] = null;
            else ev[e] = "";
            return null;
        });
        return ev;
    };
    renderText = (label, key, multiline = false, f_width) => {
        const { event } = this.state;
        return (
            <Grid lg={f_width ? 12 : 6} xl={f_width ? 12 : 6} sm={12} md={12}>
                <Typography variant="h6" style={{ width: 150 }}>
                    {label}:
                </Typography>
                <TextField
                    rows={multiline ? 2 : 1}
                    rowsMax={multiline ? 4 : 1}
                    multiline={multiline}
                    style={{ width: "70%", marginLeft: 20 }}
                    value={event[key]}
                    onChange={(e) => {
                        let ev = event;
                        ev[key] = e.target.value;
                        this.setState({ event: ev });
                    }}
                />
            </Grid>
        );
    };
    renderUserDropdown = (label, key, opts, multiselect = false, f_width) => {
        const { event } = this.state;

        return (
            <Grid lg={f_width ? 12 : 6} xl={f_width ? 12 : 6} sm={12} md={12}>
                <Typography style={{ width: 200 }} variant="h6">
                    <b>{label}:</b>
                </Typography>
                <Select
                    style={{ marginLeft: 40, width: "50%" }}
                    value={
                        multiselect && event[key] !== undefined
                            ? event[key].map((e) => {
                                  return _.get(e, "uid") || null;
                              })
                            : multiselect && event[key] === undefined
                            ? []
                            : event[key]
                    }
                    multiple={multiselect}
                    onChange={(e) => {
                        let ev = event;
                        if (multiselect) {
                            let newArray = _.flattenDeep(
                                _.compact(
                                    e.target.value.map((g) => {
                                        return _.compact(
                                            opts.map((r) => {
                                                if (g === r.uid) {
                                                    return r;
                                                } else return false;
                                            })
                                        );
                                    })
                                )
                            );

                            ev[key] = newArray;
                            this.setState({ event: ev });
                        } else {
                            ev[key] = e.target.value;
                            this.setState({ event: ev });
                        }
                    }}
                >
                    {opts.map((e) => {
                        return (
                            <MenuItem
                                key={e.uid}
                                value={multiselect ? e.uid : e.user_name}
                            >
                                {e.user_name}
                            </MenuItem>
                        );
                    })}
                </Select>
            </Grid>
        );
    };
    renderEquipmentDropdown = (label, key, opts, f_width) => {
        const { event } = this.state;

        return (
            <Grid lg={f_width ? 12 : 6} xl={f_width ? 12 : 6} sm={12} md={12}>
                <Typography style={{ width: 200 }} variant="h6">
                    <b>{label}:</b>
                </Typography>
                <Select
                    style={{ marginLeft: 40, width: "50%" }}
                    value={
                        event[key] !== undefined
                            ? event[key].map((e) => {
                                  return _.get(e, "uid") || null;
                              })
                            : event[key] === undefined
                            ? []
                            : event[key]
                    }
                    multiple={true}
                    onChange={(e) => {
                        let newArray = _.flattenDeep(
                            _.compact(
                                e.target.value.map((g) => {
                                    return _.compact(
                                        opts.map((d) => {
                                            if (g === d.uid) {
                                                return d;
                                            } else return false;
                                        })
                                    );
                                })
                            )
                        );
                        let ev = event;
                        ev[key] = newArray;
                        this.setState({ event: ev });
                    }}
                >
                    {opts.map((e) => {
                        return (
                            <MenuItem key={e.uid} value={e.uid}>
                                {e.name}
                            </MenuItem>
                        );
                    })}
                </Select>
            </Grid>
        );
    };
    renderVehicleDropdown = (label, key, opts, f_width) => {
        const { event } = this.state;

        return (
            <Grid lg={f_width ? 12 : 6} xl={f_width ? 12 : 6} sm={12} md={12}>
                <Typography style={{ width: 200 }} variant="h6">
                    <b>{label}:</b>
                </Typography>
                <Select
                    style={{ marginLeft: 40, width: "50%" }}
                    value={
                        event[key] !== undefined
                            ? event[key].map((e) => {
                                  return _.get(e, "machine_reg") || null;
                              })
                            : event[key] === undefined
                            ? []
                            : event[key]
                    }
                    multiple={true}
                    onChange={(e) => {
                        let newArray = _.flattenDeep(
                            _.compact(
                                e.target.value.map((g) => {
                                    return _.compact(
                                        opts.map((d) => {
                                            if (g === d.machine_reg) {
                                                return d;
                                            } else return false;
                                        })
                                    );
                                })
                            )
                        );
                        let ev = event;
                        ev[key] = newArray;
                        this.setState({ event: ev });
                    }}
                >
                    {opts.map((e) => {
                        return (
                            <MenuItem key={e.machine_reg} value={e.machine_reg}>
                                {e.machine_desc + " - " + e.machine_reg}
                            </MenuItem>
                        );
                    })}
                </Select>
            </Grid>
        );
    };
    renderDropDown = (label, key, opts, f_width) => {
        const { event } = this.state;
        return (
            <Grid lg={f_width ? 12 : 6} xl={f_width ? 12 : 6} sm={12} md={12}>
                <Typography style={{ width: 200 }} variant="h6">
                    {label}:
                </Typography>
                <Select
                    style={{ marginLeft: 40, width: "50%" }}
                    value={
                        this.state.event[key].uid === ""
                            ? "N/A"
                            : this.state.event[key].uid
                    }
                    onChange={(e) => {
                        let ev = event;
                        let User = null;
                        opts.map((f) => {
                            if (e.target.value === f.uid) {
                                User = f;
                            }
                            return null;
                        });
                        ev[key] = User;
                        this.setState({ event: ev });
                    }}
                >
                    {opts.map((e) => {
                        return (
                            <MenuItem key={e.uid} value={e.uid}>
                                {e.user_name}
                            </MenuItem>
                        );
                    })}
                </Select>
            </Grid>
        );
    };
    renderDate(label, key, f_width) {
        const { event } = this.state;
        return (
            <Grid lg={f_width ? 12 : 6} xl={f_width ? 12 : 6} sm={12} md={12}>
                <Typography variant="h6">
                    <b>{label}</b>
                </Typography>
                <DayPickerInput
                    value={event[key] === "N/A" ? "" : event[key]}
                    placeholder={"Select " + label}
                    formatDate={formatDate}
                    parseDate={parseDate}
                    format="DD-MM-YYYY"
                    onDayChange={(day) => {
                        let ev = event;
                        ev[key] = moment(day).format("DD-MM-YYYY");
                        this.setState({ event: ev });
                    }}
                />
            </Grid>
        );
    }
    render() {
        const {
            isOpen,
            isNewEvent,
            track_id,
            users,
            closeModal,

            department,
            area,
        } = this.props;
        let filteredUsers = _.compact(
            users.map((e) => {
                if (e.departments && department)
                    return e.departments.includes(department) ? e : null;

                if (e.areas && area) return e.areas.includes(area) ? e : null;

                return e;
            })
        );

        return (
            <Modal isOpen={isOpen}>
                <ModalHeader
                    style={{
                        textAlign: "center",
                        display: "inline-block",
                    }}
                >
                    {`${isNewEvent ? "New" : "Edit"} Event`}
                </ModalHeader>

                <ModalBody>
                    <Grid container spacing={3}>
                        {this.renderText("Name", "job_name", false, true)}
                        {this.renderText("Location", "address", false, true)}
                        {this.renderDate("Start Date", "start_date", false)}
                        {this.renderDate("End Date", "end_date", false)}
                        {this.renderUserDropdown(
                            "Assigned Manager",
                            "assigned_manager",
                            filteredUsers || [],
                            false,
                            true
                        )}
                        {this.renderDropDown(
                            "Assigned Supervisor",
                            "assigned_supervisor",
                            filteredUsers || [],
                            true
                        )}
                        {this.renderUserDropdown(
                            "Crew",
                            "assigned_operatives",
                            filteredUsers || [],
                            true,
                            true
                        )}

                        {this.renderVehicleDropdown(
                            "Vehicles",
                            "job_vehicles",
                            this.props.vehicles || [],
                            true
                        )}
                        {this.renderEquipmentDropdown(
                            "Equipment",
                            "job_equipment",
                            this.props.equipment || [],
                            true
                        )}
                    </Grid>
                </ModalBody>
                <ModalFooter>
                    <Button
                        onClick={() => {
                            closeModal();
                        }}
                        variant="contained"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            let event = this.state.event;
                            if (isNewEvent) {
                                event.department = department;
                                event.area = area;
                                event.event_id = Date.now().toString();
                                event.timestamp = moment().format(
                                    "DD-MM-YYYY HH:mm:ss"
                                );
                                event.track_id = track_id;
                                this.props.setEvent(event);
                            } else {
                                this.props.setEvent(event);
                            }

                            closeModal();
                        }}
                        color="primary"
                        variant="contained"
                    >
                        Submit
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
export default hot(module)(
    React.memo(
        connect(
            (store) => {
                return {
                    users: selectUserInfo(store),
                    vehicles: selectVehicleInfo(store),
                    equipment: selectEquipmentInfo(store),
                };
            },
            { setEvent }
        )(AddEditEventModal)
    )
);
